import React from "react";
import { Box, Card } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectCoverflow } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

const images = [
  { src: "/images/lucky13.jpeg", alt: "Lucky Photo 13" },
  { src: "/images/lucky14.jpeg", alt: "Lucky Photo 14" },
  { src: "/images/lucky16.jpg", alt: "Lucky with Friends" },
  { src: "/images/lucky11.jpeg", alt: "Lucky Photo 11" },
  { src: "/images/lucky12.jpeg", alt: "Lucky Photo 12" },
  { src: "/images/logo1.jpeg", alt: "Logo 1" },
  { src: "/images/logo2.jpeg", alt: "Logo 2" },
  { src: "/images/lucky17.jpg", alt: "Lucky with Friends 2" },
  { src: "/images/lucky8.jpeg", alt: "Lucky Photo 8" },
  { src: "/images/lucky9.jpeg", alt: "Lucky Photo 9" },
  { src: "/images/lucky10.jpeg", alt: "Lucky Photo 10" },
  { src: "/images/lucky15.jpeg", alt: "Lucky Photo 15" },
  { src: "/images/logo3.jpeg", alt: "Logo 3" },
  { src: "/images/logo4.jpeg", alt: "Logo 4" },
  { src: "/images/lucky5.jpeg", alt: "Lucky Photo 5" },
  { src: "/images/lucky6.jpeg", alt: "Lucky Photo 6" },
  { src: "/images/lucky7.jpeg", alt: "Lucky Photo 7" },
];

const ImageCarousel = () => {
  return (
    <Card
      elevation={3}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        background: "linear-gradient(145deg, #f0f0f0 0%, #ffffff 100%)",
      }}
    >
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="auto"
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        navigation
        pagination={{ clickable: true, dynamicBullets: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop
        style={{ padding: "40px 0" }}
      >
        {images.map((item, index) => (
          <SwiperSlide
            key={index}
            style={{
              width: "80%",
              maxWidth: "600px",
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                height: 400,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              }}
            >
              <img
                src={item.src}
                alt={item.alt}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Card>
  );
};

export default ImageCarousel;
